import io from 'socket.io-client';
import React from 'react'

import { getAuthSocketData, showMessage, log } from '../../config/utils';
import { SOCKET_EVENTS } from '../../config/constants';

import { updateMemberState } from './actions';
import { updateAgentMonitoringState } from '../agent_monitoring_details/actions';
import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes';
import { UPDATE_AGENT_LIVE_STATS } from '../agent_monitoring_details/actiontypes';
import {
  MAKE_MEMBER_PAGE_SOCKET_CONNECTION,
  MEMBER_SOCKET_DISCONNECT,
  EMIT_MEMBER_CUSTOM_EVENT,
  UPDATE_TRANSFER_CHAT_DATA,
  LOAD_AGENT_LIST_FOR_SELECTED_GROUP,
  AGENT_AVAILABILITY_UPDATE,
} from './actiontypes';

const registerSocketListener = (store, socket) => {
  // let agent_kpi_timer = false;
  socket.on(SOCKET_EVENTS.CONNECT, () => {
    log('member socket connected', socket);
    store.dispatch(updateMemberState(socket.connected, "is_socket_connected"));
  });

  socket.on(SOCKET_EVENTS.CONNECT_ERROR, error => {
    log('member socket connect error', error);
    store.dispatch(updateMemberState(socket.connected, "is_socket_connected"));
  });

  socket.on(SOCKET_EVENTS.ERROR, error => {
    log(' member socket error', error);
    store.dispatch(updateMemberState(socket.connected, "is_socket_connected"));
  });

  socket.on(SOCKET_EVENTS.DISCONNECT, reason => {
    store.dispatch(updateMemberState(socket.connected, "is_socket_connected"));
    if (reason === 'io server disconnect')
      socket.connect();
    // if (agent_kpi_timer)
    //   clearInterval(agent_kpi_timer);
  });

  socket.on(SOCKET_EVENTS.AVAILABILITY_UPDATE, payload => {
    log('member availitity update', payload);
    store.dispatch({
      type: AGENT_AVAILABILITY_UPDATE,
      payload,
    });
  });

  socket.on(SOCKET_EVENTS.GROUP_LIVE_STATS, payload => {
    if (payload && payload.data && payload.data.group && payload.data.columns) {
      payload.data.columns.forEach(col => {
        if (col.getCellHtml) {
          const cellHtml = new Function("return " + col.getCellHtml)()
          // eslint-disable-next-line react/display-name
          col.render = (text, record) => {
            const html = cellHtml(text, record)
            return <div dangerouslySetInnerHTML={{ __html: html }} />
          }
        }
      })
      const group_data = {
        data: payload.data.group,
        columns: payload.data.columns
      };
      store.dispatch(updateAgentMonitoringState(group_data, 'groups'));
    }
  });

  socket.on(SOCKET_EVENTS.AGENT_LIVE_STATS, payload => {
    log('agent live stats', payload);
    if (payload && payload.data && payload.data.columns && payload.data.agentList) {
      payload.data.columns.forEach(col => {
        if (col.sorter)
          col.sorter = new Function('return ' + col.sorter)()
        if (col.getCellHtml) {
          const cellHtml = new Function('return ' + col.getCellHtml)()
          // eslint-disable-next-line react/display-name
          col.render = (text, record) => {
            const html = cellHtml(text, record)
            return <div dangerouslySetInnerHTML={{ __html: html }} />
          }
        }
      });
      store.dispatch({
        type: UPDATE_AGENT_LIVE_STATS,
        payload: {
          columns: payload.data.columns,
          data: payload.data.agentList
        },
      });
    }
  });
};

const middleware = () => {
  let socket = null;
  return store => next => action => {
    switch (action.type) {
      case MAKE_MEMBER_PAGE_SOCKET_CONNECTION: {
        if (socket !== null) {
          socket.close();
        }
        const AUTH_SOCKET_DATA = getAuthSocketData();
        socket = io(action.host, AUTH_SOCKET_DATA);
        registerSocketListener(store, socket);
        break;
      }

      case EMIT_MEMBER_CUSTOM_EVENT: {
        if (socket && action.event) {
          log(`emit event ${action.event}`, action.payload);
          if (action.callback)
            socket.emit(action.event, action.payload, action.callback);
          else
            socket.emit(action.event, action.payload);
        }
        break;
      }

      case LOAD_AGENT_LIST_FOR_SELECTED_GROUP: {
        if (socket) {
          store.dispatch({
            type: PAGE_LOADING,
            payload: "loading",
          });
          socket.emit(SOCKET_EVENTS.TRANSFER_AVAILABILITY_LIST, action.payload, (err, res) => {
            log('transfer avaliability list res', res);
            store.dispatch({
              type: PAGE_LOADED,
            });
            if (!err && res && res.data) {
              store.dispatch({
                type: UPDATE_TRANSFER_CHAT_DATA,
                payload: res.data,
              });
            } else {
              showMessage('error', res && res.message ? res.message : "transfer avaliability list event error occured");
            }
          });
        }
        break;
      }

      case MEMBER_SOCKET_DISCONNECT:
        if (socket !== null) {
          log('member socket disconnected', socket);
          socket.close();
        }
        socket = null;
        break;

      default:
        return next(action);
    }
  };
};

export default middleware();



// WEBPACK FOOTER //
// ./src/data/redux/member_details/middleware.js